export default __webpack_public_path__ + "static/media/warningBlack.91fb4b1a.svg";